module.exports = __webpack_public_path__ + "img/goodcase03.f34bf2e2.png";